export default {
    url: '/role/:id',
    template: '<user-group-detail-role role="vm.role"/>',
    resolve: {
        role (ClassifierResource, $stateParams) {
            return ClassifierResource.get({ id: $stateParams.id }).$promise;
        }
    },
    controller (role) {
        this.role = role;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/group/detail/role/index.js